import Popover from '../Popover';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from '../../hooks/useNavConfig';
import { ToolTip } from '../../nav-ui-components/Tooltip';
import styled, { css, useTheme } from 'foundations-theming-specialty/utils';
import TrackedLink from '../TrackedLink';
import InfoIcon from './Icons/InfoIcon';
import { ExternalLinkIcon } from '../../nav-ui-components/Icons/ExternalLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledLink = styled(TrackedLink)(({
  theme
}) => css(["color:", ";fill:", " !important;text-decoration:underline;display:block;display:flex;align-items:center;&:hover{color:", ";}"], theme.color['text-core-on-fill-default'], theme.color['icon-core-on-fill-default'], theme.color['text-interactive-default']));
const StyledButton = styled.button.withConfig({
  displayName: "BusinessUnitsDisclaimerInfo__StyledButton",
  componentId: "j53grp-0"
})(({
  theme
}) => css(["margin:", " !important;padding:", " ", " ", " ", " !important;display:inline-block !important;width:auto !important;vertical-align:middle;"], theme.space['0'], theme.space['0'], theme.space['0'], theme.space['0'], theme.space['100']));
const StyledExternalLinkIcon = styled(ExternalLinkIcon)(({
  theme
}) => css(["padding-left:", ";height:20px;width:20px;fill:", " !important;"], theme.space['100'], theme.color['icon-core-on-fill-default']));
const BusinessUnitsDisclaimerInfo = () => {
  const [hoverIsOpen, setHoverIsOpen] = useState(false);
  const isHoveringOverTooltip = useRef(false);
  const timeoutRef = useRef(undefined);
  const hoverTimeout = 500;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const hoverText = t('nav.tools.businessUnitsPickerDisclaimerTextV2');
  const hoverTextLink = t('nav.tools.businessUnitsPickerLink');
  const businessUnitsLink = ' https://knowledge.hubspot.com/account-settings/manage-brands-with-business-unit';
  const tooltipArrowStyleOverrides = useMemo(() => {
    return {
      backgroundColor: theme.color['fill-accent-neutral-default'],
      border: 'none'
    };
  }, [theme]);
  const tooltipContentStyleOverrides = useMemo(() => {
    return Object.assign({
      backgroundColor: theme.color['fill-accent-neutral-default'],
      color: theme.color['text-core-on-fill-default'],
      border: 'none',
      maxWidth: 185,
      padding: theme.space['400']
    }, theme.typography['body-100']);
  }, [theme]);
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setHoverIsOpen(true);
    }, hoverTimeout);
  };
  const handleMouseLeave = () => {
    isHoveringOverTooltip.current = false;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setTimeout(() => {
      if (!isHoveringOverTooltip.current) {
        setHoverIsOpen(false);
      }
    }, hoverTimeout);
  };
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    placement: 'top',
    isOpen: hoverIsOpen,
    content: /*#__PURE__*/_jsx(ToolTip, {
      "data-test-id": 'business-units-tooltip',
      tooltipContentStyleOverrides: tooltipContentStyleOverrides,
      tooltipArrowStyleOverrides: tooltipArrowStyleOverrides,
      arrowPosition: "bottom",
      text: /*#__PURE__*/_jsxs(_Fragment, {
        children: [hoverText, /*#__PURE__*/_jsxs(StyledLink, {
          target: "_blank",
          href: businessUnitsLink,
          rel: "noreferrer noopener",
          children: [hoverTextLink, /*#__PURE__*/_jsx(StyledExternalLinkIcon, {})]
        })]
      }),
      id: 'BusinessUnits-disclaimer-into-tooltip',
      "aria-hidden": !hoverIsOpen,
      onMouseOver: () => isHoveringOverTooltip.current = true,
      onMouseLeave: handleMouseLeave,
      onFocus: () => isHoveringOverTooltip.current = true,
      onBlur: handleMouseLeave
    }),
    children: /*#__PURE__*/_jsx(StyledButton, {
      "data-test-id": "BusinessUnit-infoButton",
      onClick: () => setHoverIsOpen(!hoverIsOpen),
      onKeyDown: () => setHoverIsOpen(!hoverIsOpen),
      onMouseOver: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleMouseEnter,
      onBlur: handleMouseLeave,
      children: /*#__PURE__*/_jsx(InfoIcon, {})
    })
  });
};
export default BusinessUnitsDisclaimerInfo;